(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bkp-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
//document.querySelector(".showMobile .navigation-wrap ul").style.display = "none";
document.querySelector(".nav-btn").addEventListener("click", function(event){
  console.log(this.querySelector(".fa").className)
    if (this.querySelector(".fa").className == "fa fa-bars") {
      this.querySelector(".fa").className = "fa fa-times";
      document.querySelector(".showMobile .navigation-wrap ul").style.display = "block";
       document.querySelector(".showMobile .navigation-wrap ul").style.width = "100vw";        
    } else {
      document.querySelector(".showMobile .navigation-wrap ul").style.width = "0";      
      this.querySelector(".fa").className = "fa fa-bars";   
      document.querySelector(".showMobile .navigation-wrap ul").style.display = "none";
    }
});


// ================================search functionality===========================//
  
var search = document.querySelector(".showDesktop .topsearchForm input[type='text']");

search.addEventListener("keyup", function(event) {
var target_val =event.target.value;
 if(target_val !=''){
     var button_link_html='<a class="Show_All_Results" href="/search?q='+target_val+'">Show All Results</a>';
      fetch(window.Shopify.routes.root + "search/suggest.json?q="+target_val+"&resources[type]=product")
      .then((response) => response.json())
      .then((suggestions) => {
      console.log(suggestions)
      const productSuggestions = suggestions.resources.results.products;
     // console.log('length :'+ productSuggestions.length)
      if(productSuggestions.length > 0) {
        
        //console.log(productSuggestions);
        var data_html='';
        for (var i = 0; i < productSuggestions.length; i++) {
           if(i<3 && productSuggestions[i].tags.includes('Discontinued tag') !== true && productSuggestions[i].type != 'Only_adds' ){
             //console.log('exist :'+productSuggestions[i].type);
             
             data_html+= "<li><a href='"+productSuggestions[i].url+"'><img src='"+productSuggestions[i].image+"'><span class='item_title'>"+productSuggestions[i].title+"</span></a></li>";
           } 
        };
        document.getElementsByClassName("search_result")[0].innerHTML='';
        document.getElementsByClassName("search_result")[0].innerHTML=data_html+button_link_html;
           //const firstProductSuggestion = productSuggestions[0];
           // alert(`The title of the first product suggestion is: ${
           //   firstProductSuggestion.title}`
           // );
      }else{
        document.getElementsByClassName("search_result")[0].innerHTML='0 product results for "'+target_val+'"';
      }
      }
      );
 }else{
     document.getElementsByClassName("search_result")[0].innerHTML='';
 }
});

var mobile_search = document.querySelector(".showMobile .topsearchFormM input[type='text']");
mobile_search.addEventListener("keyup", function(event) {
var target_val =event.target.value;
 if(target_val !=''){
      var button_link_html='<a class="Show_All_Results" href="/search?q='+target_val+'">Show All Results</a>';
      fetch(window.Shopify.routes.root + "search/suggest.json?q="+target_val+"&resources[type]=product")
      .then((response) => response.json())
      .then((suggestions) => {
     // console.log(suggestions)
      const productSuggestions = suggestions.resources.results.products;
     // console.log('length :'+ productSuggestions.length)
      if(productSuggestions.length > 0) {
        //console.log(productSuggestions);
        
        var data_html='';
        for (var i = 0; i < productSuggestions.length; i++) {
           if(i<3 && productSuggestions[i].tags.includes('Discontinued tag') !== true && productSuggestions[i].type != 'Only_adds' ){
             data_html+= "<li><a href='"+productSuggestions[i].url+"'><img src='"+productSuggestions[i].image+"'><span class='item_title'>"+productSuggestions[i].title+"</span></a></li>";
           }
        };
        document.getElementsByClassName("mobile_search_result")[0].innerHTML='';
        document.getElementsByClassName("mobile_search_result")[0].innerHTML=data_html+button_link_html;
           //const firstProductSuggestion = productSuggestions[0];
           // alert(`The title of the first product suggestion is: ${
           //   firstProductSuggestion.title}`
           // );
      }else{
        document.getElementsByClassName("mobile_search_result")[0].innerHTML='0 product results for "'+target_val+'"';
      }
      }
      );
 }else{
     document.getElementsByClassName("mobile_search_result")[0].innerHTML='';
 }
});
// ================================End search functionality===========================//

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
//document.querySelector(".showMobile .navigation-wrap ul").style.display = "none";
document.querySelector(".nav-btn").addEventListener("click", function(event){
  
  console.log(this.querySelector(".fa").className)
    if (this.querySelector(".fa").className == "fa fa-bars") {
      this.querySelector(".fa").className = "fa fa-times";
      document.querySelector(".showMobile .navigation-wrap ul").style.display = "block";
       document.querySelector(".showMobile .navigation-wrap ul").style.width = "100vw"; 
       document.body.classList.add("menu-open");       
    } else {
      document.querySelector(".showMobile .navigation-wrap ul").style.width = "0";      
      this.querySelector(".fa").className = "fa fa-bars";   
      document.querySelector(".showMobile .navigation-wrap ul").style.display = "none";
      document.body.classList.remove("menu-open");
    }
});


// ================================search functionality===========================//
  
var search = document.querySelector(".showDesktop .topsearchForm input[type='text']");

search.addEventListener("keyup", function(event) {
var target_val =event.target.value;
 if(target_val !=''){
     var button_link_html='<a class="Show_All_Results" href="/search?q='+target_val+'">Show All Results</a>';
      fetch(window.Shopify.routes.root + "search/suggest.json?q="+target_val+"&resources[type]=product")
      .then((response) => response.json())
      .then((suggestions) => {
      console.log(suggestions)
      const productSuggestions = suggestions.resources.results.products;
     // console.log('length :'+ productSuggestions.length)
      if(productSuggestions.length > 0) {
        
        //console.log(productSuggestions);
        var data_html='';
        for (var i = 0; i < productSuggestions.length; i++) {
           if(i<3 && productSuggestions[i].tags.includes('Discontinued tag') !== true && productSuggestions[i].type != 'Only_adds' ){
             //console.log('exist :'+productSuggestions[i].type);
             
             data_html+= "<li><a href='"+productSuggestions[i].url+"'><img src='"+productSuggestions[i].image+"'><span class='item_title'>"+productSuggestions[i].title+"</span></a></li>";
           } 
        };
        document.getElementsByClassName("search_result")[0].innerHTML='';
        document.getElementsByClassName("search_result")[0].innerHTML=data_html+button_link_html;
           //const firstProductSuggestion = productSuggestions[0];
           // alert(`The title of the first product suggestion is: ${
           //   firstProductSuggestion.title}`
           // );
      }else{
        document.getElementsByClassName("search_result")[0].innerHTML='0 product results for "'+target_val+'"';
      }
      }
      );
 }else{
     document.getElementsByClassName("search_result")[0].innerHTML='';
 }
});

var mobile_search = document.querySelector(".showMobile .topsearchFormM input[type='text']");
mobile_search.addEventListener("keyup", function(event) {
var target_val =event.target.value;
 if(target_val !=''){
      var button_link_html='<a class="Show_All_Results" href="/search?q='+target_val+'">Show All Results</a>';
      fetch(window.Shopify.routes.root + "search/suggest.json?q="+target_val+"&resources[type]=product")
      .then((response) => response.json())
      .then((suggestions) => {
     // console.log(suggestions)
      const productSuggestions = suggestions.resources.results.products;
     // console.log('length :'+ productSuggestions.length)
      if(productSuggestions.length > 0) {
        //console.log(productSuggestions);
        
        var data_html='';
        for (var i = 0; i < productSuggestions.length; i++) {
           if(i<3 && productSuggestions[i].tags.includes('Discontinued tag') !== true && productSuggestions[i].type != 'Only_adds' ){
             data_html+= "<li><a href='"+productSuggestions[i].url+"'><img src='"+productSuggestions[i].image+"'><span class='item_title'>"+productSuggestions[i].title+"</span></a></li>";
           }
        };
        document.getElementsByClassName("mobile_search_result")[0].innerHTML='';
        document.getElementsByClassName("mobile_search_result")[0].innerHTML=data_html+button_link_html;
           //const firstProductSuggestion = productSuggestions[0];
           // alert(`The title of the first product suggestion is: ${
           //   firstProductSuggestion.title}`
           // );
      }else{
        document.getElementsByClassName("mobile_search_result")[0].innerHTML='0 product results for "'+target_val+'"';
      }
      }
      );
 }else{
     document.getElementsByClassName("mobile_search_result")[0].innerHTML='';
 }
});
// ================================End search functionality===========================//

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-page-header-v0"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
//document.querySelector(".showMobile .navigation-wrap ul").style.display = "none";
document.querySelector(".nav-btn").addEventListener("click", function(event){
  console.log(this.querySelector(".fa").className)
    if (this.querySelector(".fa").className == "fa fa-bars") {
      this.querySelector(".fa").className = "fa fa-times";
      document.querySelector(".showMobile .navigation-wrap ul").style.display = "block";
       document.querySelector(".showMobile .navigation-wrap ul").style.width = "100vw";        
    } else {
      document.querySelector(".showMobile .navigation-wrap ul").style.width = "0";      
      this.querySelector(".fa").className = "fa fa-bars";   
      document.querySelector(".showMobile .navigation-wrap ul").style.display = "none";
    }
});


// ================================search functionality===========================//
var search = document.querySelector(".showDesktop .topsearchForm input[type='text']");

search.addEventListener("keyup", function(event) {
var target_val =event.target.value;
 if(target_val !=''){

     var button_link_html='<a class="Show_All_Results" href="/search?q='+target_val+'">Show All Results</a>';
      fetch(window.Shopify.routes.root + "search/suggest.json?q="+target_val+"&resources[type]=product")
      .then((response) => response.json())
      .then((suggestions) => {
      console.log(suggestions)
      const productSuggestions = suggestions.resources.results.products;
     // console.log('length :'+ productSuggestions.length)
      if(productSuggestions.length > 0) {
        console.log(productSuggestions);
        
        var data_html='';
        for (var i = 0; i < productSuggestions.length; i++) {
           if(i<3){
             data_html+= "<li><a href='"+productSuggestions[i].url+"'><img src='"+productSuggestions[i].image+"'><span class='item_title'>"+productSuggestions[i].title+"</span></a></li>";
           } 
        };
        document.getElementsByClassName("search_result")[0].innerHTML='';
        document.getElementsByClassName("search_result")[0].innerHTML=data_html+button_link_html;
           //const firstProductSuggestion = productSuggestions[0];
           // alert(`The title of the first product suggestion is: ${
           //   firstProductSuggestion.title}`
           // );
      }else{
        document.getElementsByClassName("search_result")[0].innerHTML='0 product results for "'+target_val+'"';
      }
      }
      );
 }else{
     document.getElementsByClassName("search_result")[0].innerHTML='';
 }
});

var mobile_search = document.querySelector(".showMobile .topsearchFormM input[type='text']");
mobile_search.addEventListener("keyup", function(event) {
var target_val =event.target.value;
 if(target_val !=''){
      var button_link_html='<a class="Show_All_Results" href="/search?q='+target_val+'">Show All Results</a>';
      fetch(window.Shopify.routes.root + "search/suggest.json?q="+target_val+"&resources[type]=product")
      .then((response) => response.json())
      .then((suggestions) => {
     // console.log(suggestions)
      const productSuggestions = suggestions.resources.results.products;
     // console.log('length :'+ productSuggestions.length)
      if(productSuggestions.length > 0) {
        //console.log(productSuggestions);
        
        var data_html='';
        for (var i = 0; i < productSuggestions.length; i++) {
           if(i<3){
             data_html+= "<li><a href='"+productSuggestions[i].url+"'><img src='"+productSuggestions[i].image+"'><span class='item_title'>"+productSuggestions[i].title+"</span></a></li>";
           }
        };
        document.getElementsByClassName("mobile_search_result")[0].innerHTML='';
        document.getElementsByClassName("mobile_search_result")[0].innerHTML=data_html+button_link_html;
           //const firstProductSuggestion = productSuggestions[0];
           // alert(`The title of the first product suggestion is: ${
           //   firstProductSuggestion.title}`
           // );
      }else{
        document.getElementsByClassName("mobile_search_result")[0].innerHTML='0 product results for "'+target_val+'"';
      }
      }
      );
 }else{
     document.getElementsByClassName("mobile_search_result")[0].innerHTML='';
 }
});
// ================================End search functionality===========================//

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["only_adds_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

// ================================search functionality===========================//
  
var search = document.querySelector(".showDesktop .topsearchForm input[type='text']");

search.addEventListener("keyup", function(event) {

var target_val =event.target.value;
 if(target_val !=''){
     var button_link_html='<a class="Show_All_Results" href="/search?q='+target_val+'">Show All Results</a>';
      fetch(window.Shopify.routes.root + "search/suggest.json?q="+target_val+"&resources[type]=product")
      .then((response) => response.json())
      .then((suggestions) => {
      console.log(suggestions)
      const productSuggestions = suggestions.resources.results.products;
     // console.log('length :'+ productSuggestions.length)
      if(productSuggestions.length > 0) {
        
        //console.log(productSuggestions);
        var data_html='';
        for (var i = 0; i < productSuggestions.length; i++) {
           if(i<3 && productSuggestions[i].tags.includes('Discontinued tag') !== true && productSuggestions[i].type != 'Only_adds' ){
             //console.log('exist :'+productSuggestions[i].type);
             
             data_html+= "<li><a href='"+productSuggestions[i].url+"'><img src='"+productSuggestions[i].image+"'><span class='item_title'>"+productSuggestions[i].title+"</span></a></li>";
           } 
        };
        document.getElementsByClassName("search_result")[0].innerHTML='';
        document.getElementsByClassName("search_result")[0].innerHTML=data_html+button_link_html;
           //const firstProductSuggestion = productSuggestions[0];
           // alert(`The title of the first product suggestion is: ${
           //   firstProductSuggestion.title}`
           // );
      }else{
        document.getElementsByClassName("search_result")[0].innerHTML='0 product results for "'+target_val+'"';
      }
      }
      );
 }else{
     document.getElementsByClassName("search_result")[0].innerHTML='';
 }
});

var mobile_search = document.querySelector(".showMobile .topsearchFormM input[type='text']");
mobile_search.addEventListener("keyup", function(event) {
var target_val =event.target.value;
 if(target_val !=''){
      var button_link_html='<a class="Show_All_Results" href="/search?q='+target_val+'">Show All Results</a>';
      fetch(window.Shopify.routes.root + "search/suggest.json?q="+target_val+"&resources[type]=product")
      .then((response) => response.json())
      .then((suggestions) => {
     // console.log(suggestions)
      const productSuggestions = suggestions.resources.results.products;
     // console.log('length :'+ productSuggestions.length)
      if(productSuggestions.length > 0) {
        //console.log(productSuggestions);
        
        var data_html='';
        for (var i = 0; i < productSuggestions.length; i++) {
           if(i<3 && productSuggestions[i].tags.includes('Discontinued tag') !== true && productSuggestions[i].type != 'Only_adds' ){
             data_html+= "<li><a href='"+productSuggestions[i].url+"'><img src='"+productSuggestions[i].image+"'><span class='item_title'>"+productSuggestions[i].title+"</span></a></li>";
           }
        };
        document.getElementsByClassName("mobile_search_result")[0].innerHTML='';
        document.getElementsByClassName("mobile_search_result")[0].innerHTML=data_html+button_link_html;
           //const firstProductSuggestion = productSuggestions[0];
           // alert(`The title of the first product suggestion is: ${
           //   firstProductSuggestion.title}`
           // );
      }else{
        document.getElementsByClassName("mobile_search_result")[0].innerHTML='0 product results for "'+target_val+'"';
      }
      }
      );
 }else{
     document.getElementsByClassName("mobile_search_result")[0].innerHTML='';
 }
});
// ================================End search functionality===========================//

                                

  } catch(e) { console.error(e); }
})();
})();
